import { createFileRoute, redirect, } from '@tanstack/react-router';
export const Route = createFileRoute('/psychotherapie/$userId/$customerId')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/profile/$customerId/$userId/$',
            params,
            replace: true,
        });
    },
});
//# sourceMappingURL=$userId.$customerId.js.map